module.exports = __webpack_public_path__ + "img/s-mob-1.5e8fd035.webp";